<template>
  <div class="luckDraw">
    <img class="bg" :src="resourceUrl + 'aliapp/20191012/2020ny.png'" alt="大方租车 春节活动"/>
    <div class="autodrawBtn" @click="canDraw"></div><!-- 领取优惠券 -->
    <div class="activityRules" @click="playInfoFn(1)"></div><!-- 活动细则 -->
    <div class="infoBtn" @click="playInfoFn(2)"></div><!-- 抽奖规则 -->
    <div class="myPrize" @click="goMyPrize"></div><!-- 我的奖品 -->
    <div class="shareBox" @click="shareLuckDraw"></div><!-- 分享 -->
    <div class="drawNum">{{ luckDrawNum==0?'点击分享，获取更多抽奖机会':'还有'+ luckDrawNum +'次抽奖机会' }}</div>
    <div class="drawWarp">
      <img class="panBg" :class="{'on': isStart}" :style="'transform: rotate(' + curPos + 'deg);'" :src="resourceUrl + 'aliapp/20191012/pan.png'">
      <img class="startBtn" :src="resourceUrl + 'aliapp/20191012/btns.png'" @click="startLuck" ><!-- 转盘开始 -->
    </div>
    <div class="playInfoTips" v-if="showPlayInfo">
      <div class="mockBox" @click="playInfoFn"></div>
      <div class="centerWarp">
        <h3>{{ showPlayInfo.title }}</h3>
        <p v-for="item in showPlayInfo.content">{{ item }}</p>
        <div class="tipsCloseBtn" @click="playInfoFn">确认</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { apiMode, resourceUrl, orderSource,mySelfURL } from "@/utils/env";
  import {
    getConsumerCoupons, //获取用户优惠券
    DrawCoupon, //领取优惠券
    luckDrawInit, //获取抽奖活动信息
    getLotteryCount, //获得当前抽奖次数
    addLotteryCount, //增加抽奖次数
    luckDraw, //开始抽奖
    getCurrentMemberInfo, //获取用户信息
  } from '@/utils/api'
  export default {
    name: 'luckDraw',
    data(){
      return {
        resourceUrl: resourceUrl,
        activityID: 224,
        showPlayInfo: null,
        luckDrawNum: 0,
        curPos: 0,
        isStart: false,
        lastTime: null,
        modelType1: {
          title: '活动细则',
          content: ['1. 2020年春节订单即日起接受预定。', '2. 优惠券使用规则：', '①  588元、288元、188元优惠券、升级优惠券及无门槛优惠券均适用于租期在2020年1月22日-1月31日内的春节订单； ', '②588元及升级后优惠券适用于租期在2020年1月17日-2月6日内且租满15天（含）及以上的订单；', ' ③288元及升级后优惠券适用于租期在2020年1月20日-2月1日内且租满9天（含）及以上的订单； ', ' ④188元及升级后优惠券适用于租期在2020年1月22日-1月31日内且租满7天（含）及以上的订单； ', ' ⑤10元、20元无门槛优惠券可与588元、288元、188元优惠券及升级券叠加使用；', ' ⑥春节免单大奖共抽取3名，最高享受免单金额1000元。 ', ' 3. 优惠金额为车辆日租金，领券后由系统自动减免，其他费用正常收取。 ', ' 4. 优惠券能否使用根据租期开放而定。']
        },
        modelType2: {
          title: '抽奖规则',
          content: ['1. 活动时间：即日起至2020年1月31日。', ' 2. 每人有1次抽奖机会，分享抽奖活动页面1次，即多获得1次抽奖机会，抽奖次数不限。', ' 3.活动奖品：', ' ① 无门槛优惠券及升级优惠券均适用于租期包含2020年1月22日-1月31日（共10天）的春节订单；', ' ②10元、20元无门槛优惠券可与588元、288元、188元优惠券叠加使用；', ' ③抽中升级优惠券，即可将588元优惠券升级为688元，288元优惠券升级为388元，188元优惠券升级为288元。', ' ④升级后的优惠券可与10元、20元无门槛优惠券叠加使用；', ' ⑤春节免单大奖共抽取3名，最高享受免单金额1000元。', ' 4. 抽中免单大奖的用户请联系客服400-666-8818，其他抽中的奖品将直接放入“我的奖品”。', ' 5. 如有疑问请拨打客服电话：400-666-8818。']
        },
        couponList: [ //领券列表
          { name: "租15天减588元", offerId: 215, isHave: false },
          { name: "租9天减288元", offerId: 217, isHave: false },
          { name: "租7天减188元", offerId: 220, isHave: false }
        ],
        posList:[
          { name: "恭喜您获得10元无门槛券", pos: 180, id: 0 },
          { name: "恭喜您获得20元无门槛券", pos: 240, id: 0 },
          { name: "恭喜您获得288元优惠券", pos: 120, id: 0 },
          { name: "恭喜您获得688元优惠券", pos: 60, id: 0 },
          { name: "恭喜您获得388元优惠券", pos: 0, id: 0 },
          { name: "恭喜您获得免单", pos: 300, id: 0 }
        ],
      }
    },
    created () {},
    mounted () {
      setTimeout(()=>{
        window.addDrawCount = this.addDrawCount;
        this.init();
      },300);
    },
    methods: {
      init () {
        let nowTime = parseInt(Date.parse(new Date())/1000);
        let lastTime = parseInt(Date.parse(new Date('2020-01-31 23:55:00'))/1000);
        if( nowTime > lastTime ){
          // 最后时间 2020-01-31 23:55:00;
          this.flexible.alert({
            title: '提示',
            content:"活动已结束，感谢对大方的支持~",
            buttonText: '确定',
            success () {
              if( orderSource==17 ){
                window.webkit.messageHandlers.goHome.postMessage(null);
              } else if ( orderSource==16 ){
                dfpanda.goHome();
              }
            }
          });
        } else {
          if( this.$route.query && this.$route.query.id ){
            this.activityID = this.$route.query.id
          }
          setTimeout(()=>{
            this.getLuckDrawInit();
          }, 500)
        }
      },
      async getLuckDrawInit () {
        let res = await luckDrawInit({
          data: { offerID: this.activityID }
        });
        if( res.Code==100 ){
          for(let i = 0;i < this.posList.length;i++){
            this.posList[i].id = res.Data[i] || 0;
          }
          this.initCount();
        }
        if( res.Code==17007 ){
          this.flexible.showToast({
            content: '请登录/注册！',
            duration: 1200,
            success: ()=>{
              // console.log('调用原生方法跳转登录');
              if( orderSource==17 ){
                window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: "app", url: "/LonginActivity"}));
              } else if ( orderSource==16 ){
                dfpanda.openPage(JSON.stringify({type: "app", url: "/app/LonginActivity"}));
              }
            }
          });
        }
      },
      async getCoupon () {
        let geted = false;
        for ( let i in this.couponList ) {
          if( this.couponList[i].isHave ){
            geted = true
          } else {
            let dRes = await DrawCoupon({
              data: {
                offerId: this.couponList[i].offerId,
                orgID: 0,
              }
            });
            if( dRes.Code==100 ){
              geted = true
            }
          }
        }
        if( geted ){
          this.flexible.showToast({
            content: '恭喜您领券成功！立即开启自驾之旅吧~'
          })
        } else {
          this.flexible.showToast({
            content: '优惠券未领取成功~'
          })
        }
      },
      playInfoFn (type=null) {
        if( type==1 ){
          this.showPlayInfo = this.modelType1
        } else if( type==2 ) {
          this.showPlayInfo = this.modelType2
        } else {
          this.showPlayInfo = null;
        }
      },
      async canDraw () {
        let userCoupons = [];
        let res = await getConsumerCoupons();
        if( res.Code==100 ){
          userCoupons = res.Data || [];
          for( let i = 0; i<userCoupons.length; i++ ){
            for( let j in this.couponList ){
              if( userCoupons[i].OfferID == this.couponList[j].offerId ){
                this.couponList[j].isHave = true
              }
            }
          }
        }
        this.getCoupon();
      },
      goMyPrize () { // 我的奖品
        // this.$router.replace({name: 'couponlist'});
        let _url = mySelfURL +  '/couponlist';
        if( orderSource==17 ){
          window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: "html", url: _url}));
        } else if ( orderSource==16 ){
          dfpanda.openPage(JSON.stringify({type: "html", url: _url}));
        }
      },
      shareLuckDraw () { // 分享
        console.log('分享 doShare');
        let userinfo = localStorage.getItem('userinfo');
        let showname = '大方租车';
        if( userinfo ){
          showname = JSON.parse(userinfo).Name || JSON.parse(userinfo).Telephone
        }
        let _content = JSON.stringify({
          title: showname + '邀您抽取春节免单大奖',
          summary: '春节自驾，最高立减688，再送7天免费用车~',
          // pic: 'https://cms.dafang24.com/aliapp/20191012/APPcode.png',
          pic: 'https://cms.dafang24.com/aliapp/20191012/2020ny_share.png',
          path: 'pages/drawCoupon/drawCoupon', // 微信小程序路径
          url: 'https://qr.alipay.com/s6x17480zwbfcrizhhnye87' // 支付宝小程序
        });
        console.log(_content);
        if( orderSource==17 ){
          window.webkit.messageHandlers.doShare.postMessage(_content);
        } else if ( orderSource==16 ){
          dfpanda.doShare(_content);
        }
      },
      async addDrawCount(){
        let res = await addLotteryCount();
        if(res.Code == 100){
          this.initCount();
          this.flexible.alert({
            title: '分享成功',
            content:"获得1次抽奖机会!"
          });
          return '分享成功';
        }
        return '分享失败';
      },
      async initCount (){
        let res = await getLotteryCount();
        if( res.Code == 100 ){
          this.luckDrawNum = res.Data;
        }
      },
      async startLuck () {
        let nowTime = new Date();
        if( this.isStart ){ return  }
        if( !this.lastTime || nowTime - this.lastTime > 5000 ){
          this.lastTime = nowTime;
          let res = await luckDraw({
            data:{ offerID: this.activityID },
            isLoading: true,
            loadContent: "开始抽奖..."
          });
          if( res.Code==100 ){
            this.luckDrawNum = this.luckDrawNum - 1;
            for( let item of this.posList ){
              console.log(res.Data, item);
              if( res.Data==item.id ){
                this.isStart = true;
                this.curPos = 360 * 8 + item.pos;
                setTimeout(()=>{
                  this.lastTime = null;
                  this.isStart = false;
                  this.curPos = this.curPos - 360 * 8;
                  this.flexible.alert({
                    title: '中奖结果',
                    content: item.name
                  });
                  this.initCount()
                }, 3100)
              }
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .luckDraw {
    position: relative;
    img.bg {
      width: 100%;
    }
    .activityRules, .infoBtn, .autodrawBtn, .myPrize, .shareBox {
      background-color: rgba(0,123,134, 0);
    }
    .activityRules { /* 活动细则 */
      width: 70px; height: 150px;
      position: absolute;
      top: 40px; right: 0;
    }
    .infoBtn { /* 抽奖规则 */
      width: 210px; height: 70px;
      position: absolute;
      top: 2320px; left: 390px;
    }
    .myPrize { /* 我的奖品 */
      width: 210px; height: 70px;
      position: absolute;
      top: 2320px; left: 142px;
    }
    .drawNum { /* 抽奖次数 */
      width: 100%; height: 70px;
      line-height: 70px;
      text-align: center;
      position: absolute;
      top: 2510px; left: 0;
    }
    .autodrawBtn { /* 领取优惠券 */
      width: 400px; height: 90px;
      position: absolute;
      top: 1310px; left: 170px;
    }
    .shareBox { /* 分享 */
      width: 460px; height: 90px;
      position: absolute;
      top: 2420px; left: 140px;
    }
    .drawWarp {
      width: 550px;
      position: absolute;
      top: 1730px; left: 100px;
      display: flex;
      align-items: center;
      .panBg {
        width: 100%;
      }
      .on {
        transition: all 3s ease;
      }
      .startBtn {
        width: 168px;
        position: absolute;
        left: 50%;
        margin-left: -84px;
      }
    }
    .playInfoTips {
      position: fixed;
      top: 0; left: 0;
      width: 100%; height: 100%;
      display: flex;
      align-content: center;
      align-items: center;
      .mockBox {
        position: absolute;
        top: 0; left: 0;
        width: 100%; height: 100%;
        background-color: rgba(0, 0, 0, .6);
      }
      .centerWarp {
        width: 75%;
        position: relative; z-index: 2;
        padding: 10px 40px 100px;
        background-color: #f2f2f2;
        margin: 0 auto;
        border-radius: 6px;
        /*box-shadow: 0 0 120px rgba(0, 0, 0, 0.8);*/
        h3 {
          text-align: center;
          padding: 8px 0;
          margin-bottom: 5px;
          font-size: 32px;
        }
        p {
          line-height: 36px;
          padding-bottom: 10px;
        }
        .tipsCloseBtn {
          width: 100%;
          height: 90px;
          line-height: 90px;
          text-align: center;
          font-size: 27px;
          color: #1d75dc;
          position: absolute;
          left: 0; bottom: 0;
          background-color: rgba(255, 255, 255, .4);
        }
      }
    }
  }
</style>
